function sumConfig(config) {
    const configArray = [];
    for(let key in config) {
        if(config[key] !== false) {
            let temp = JSON.parse(JSON.stringify(config[key]))

            if (key === 'tabletop' && config[key].countCup === 2) {
                temp.price = temp.price + 3530;
            } 

            if (key === 'sink' && 'flap' in config[key] && config[key].flap?.price) {
                temp.price = temp.price + config[key].flap.price;
            }

            configArray.push(temp)
        }
    }

    return configArray.reduce((sum,config) => sum + Number(config.price), 0);
}

export {sumConfig}